import { useState, type ReactNode } from "react";
import clsx from "clsx";

export interface TabDef {
  id: string;
  label: string;
}

export function ProductTabs({
  tabs,
  defaultTab,
  children
}: {
  tabs: TabDef[];
  defaultTab?: string;
  children: (activeTab: string) => ReactNode;
}) {
  const [active, setActive] = useState(defaultTab ?? tabs[0]?.id ?? "");

  return (
    <div>
      <div role="tablist" className="flex items-center gap-6 border-b border-border overflow-x-auto no-scrollbar">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active === t.id}
            onClick={() => setActive(t.id)}
            className={clsx(
              "relative py-3 text-sm font-medium whitespace-nowrap transition-colors duration-200",
              active === t.id ? "text-accent" : "text-ink-muted hover:text-ink"
            )}
          >
            {t.label}
            {active === t.id && <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-accent rounded-full" />}
          </button>
        ))}
      </div>
      <div className="pt-6">{children(active)}</div>
    </div>
  );
}
